import { MenuService } from './../../../shared/service/menu/menu.service';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/shared/interfaces/user';
import { LoginService } from 'src/app/shared/service/authentication/login.service';
import { RolesPermissionsService } from 'src/app/shared/service/catalogs/rolesPermissions/roles-permissions.service';
import { Responses } from 'src/app/shared/interfaces/responses';

@Component({
  selector: 'app-vertical-sidebar',
  templateUrl: './vertical-sidebar.component.html',
  styleUrls: []
})

export class VerticalAppSidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;


  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>()


  private _mobileQueryListener: () => void;
  status = true;
  showMenu = '';
  itemSelect: number[] = [];
  parentIndex = 0;
  childIndex = 0;

  menuData: any;
  filteredMenuData: any;
  // Objeto de usuarios
  public user !: User;

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  subclickEvent(): void {
    this.status = true;
  }
  scrollToTop(): void {
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0
    });
  }

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private cookieService: CookieService,
    private router: Router,
    private toastService: ToastrService,
    private menuService: MenuService,
    private loginService: LoginService,
    private rolesPermissionsService : RolesPermissionsService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.menuService.getMenu().subscribe({
      next: resp => {
        //iteramos la respuesta para eliminar los valores children y subchild vacios
        resp.data.forEach((children: any) => {
          if (children.children.length > 0) {
            children.children.forEach((subchildren: any) => {
              subchildren.type = subchildren.type.type
              if (subchildren.subchild.length === 0) {
                delete subchildren.subchild;
              }
            });
          }
          children.type = children.type.type
        });
        // this.menuData = resp.data
        this.filteredMenuData = resp.data
      },
      error: error => {
        console.log(error);
      }
    })

    // Verificamos el token del usuario
    this.loginService.verificaAutenticacion().subscribe({
      next: (resp) => {
        this.user = resp.data
     },
     complete:() =>{
        this.getPermissionsByUser(this.user.Id!, this.user.IdRol!)
      }
    });
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  handleNotify() {
    if (window.innerWidth < 1024) {
      this.notify.emit(!this.showClass);
    }
  }

  cerrarSesion() {
    this.cookieService.delete('token');
    this.toastService.success('La sesión se termino correctamente.')
    this.router.navigate(['/authentication/login']);
    localStorage.removeItem('token')
  }

    // Función que obtiene los permisos de los modulos desde la api y filtra el menu
  private getPermissionsByUser(IdUsuario: number,IdRol: number): void{
    this.rolesPermissionsService.getPermissionsByUser(IdUsuario,IdRol).subscribe({
      next: (response: Responses) =>{
        const permissions = response.data
        const modulosFilter = this.filteredMenuData.filter((elemento: any) => permissions.find((elem:any) => elem.IdModulo === elemento.Id) );
        for (const item of modulosFilter) {
          item.children=  item.children.filter((elemento: any) => permissions.find((elem:any) => elem.IdModulo === elemento.Id) );
        }
        this.menuData = modulosFilter
      }
    });
  }

}
